import { createI18n } from 'vue-i18n'
import en from './locales/en.json'
import it from './locales/it.json'

const i18n = createI18n({
  legacy: false,
  locale: localStorage.getItem('language') || 'en',
  fallbackLocale: 'en',
  globalInjection: true,
  messages: {
    en,
    it
  }
})

export default i18n
